/**
 * Calibration Report settings schema.
 *
 * On-demand-only port (ENGS-677): the report snapshots the sensors whose
 * calibration is near or past expiration. The single manual-run setting is
 * `includeNearOrExpiredOnly`, unchanged from the legacy CalibrationReport.vue
 * component this replaces so the report generation logic reads the same key.
 *
 * Recipients no longer live in this schema or the on-demand settings drawer.
 * They are managed on the report's Automatic mode screen (the
 * `#automatic-options` slot in GroupCalibrationReport.vue, rendered via
 * CalibrationSubscribers.vue), which saves through the legacy
 * `reports/calibration-report/update` endpoint into the `CalibrationReportUsers`
 * company option (the same option the monthly auto-send reads).
 */

export default {
    slug: 'calibration-report',
    icon:
        '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>'
        + '<path d="M7 20h10" />'
        + '<path d="M6 6h12" />'
        + '<path d="M12 3v3" />'
        + '<path d="M9 6l-4 8a4.5 4.5 0 0 0 8 0l-4 -8" />'
        + '<path d="M15 6l-4 8a4.5 4.5 0 0 0 8 0l-4 -8" />',
    permission: 'run_calibration_report',
    title: 'Calibration',
    description: 'Which probes are still in calibration, and which are expiring or already expired.',
    info: 'Lists probes with their calibration and expiration dates and certificate links, in three groups: nearly expired, expired within the last year, and expired longer ago. Nearly expired means expiring by the end of the month two months from now.',

    sections: [
        {
            title: 'Data Settings',
            description: 'Choose what appears in the generated report.',
            fields: [
                {
                    key: 'includeNearOrExpiredOnly',
                    type: 'toggle',
                    label: 'Only Near or Expired Calibrations',
                    description: 'When on, lists only probes that are already expired or expire by the end of the month two months from now. When off, probes with current calibrations are listed too.',
                },
            ],
        },
    ],
}
